import type { IconSvgObject } from './types';

const DollarSend01Icon: IconSvgObject = [
  ["path", { d: "M19 14.5L21.5 12L19 9.5M15.5 12H20.8912", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.0833 8.62963C12.0833 6.62504 10.0312 5 7.49994 5C4.96863 5 2.91661 6.62504 2.91661 8.62963C2.91661 10.6342 4.16661 11.7407 7.49994 11.7407C10.8333 11.7407 12.4999 12.7778 12.4999 15.3704C12.4999 17.963 10.4166 19 7.49994 19C4.58327 19 2.49994 17.5 2.49994 15.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.5 5V3M7.5 19V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DollarSend01Icon;
